import React from 'react'
import ComplaintForm from '../components/ComplaintForm';
import AppHeader from '../components/AppHeader'


function ComplaintFormPage() {
  return (
        <>
            <AppHeader/>
            <ComplaintForm/>		
        </>
    )
}

export default ComplaintFormPage